// Available colors from the TextCodeModal component
const AVAILABLE_COLORS = [
    "#ddad9e", "#f8e0c5", "#fcd39e", "#eab976", "#dec487", "#e6dcab", "#f1efb9", "#e2f1b5",
    "#bae295", "#aeea84", "#bbe4ae", "#aceea4", "#8cdd85", "#85eca4", "#bdf3d7", "#87fdd1",
    "#6fdcb4", "#a2dcf1", "#8cd2ef", "#aad2ec", "#bedcf0", "#72b0db", "#9bbbfc", "#a4a3dd",
    "#a8a1e9", "#c7bdf2", "#b29fdf", "#d789fe", "#e5a3f6", "#f4bff8", "#e895b1", "#f597a4"
];

/**
 * Get a random color from the available colors array
 * @returns {string} A hex color value
 */
export const getRandomColor = () => {
    const randomIndex = Math.floor(Math.random() * AVAILABLE_COLORS.length);
    return AVAILABLE_COLORS[randomIndex];
};

/**
 * Generate an array of unique colors for multiple codes
 * Tries to avoid using the same color twice unless necessary
 * @param {number} count - Number of colors needed
 * @param {string[]} usedColors - Array of already used colors to avoid
 * @returns {string[]} Array of hex color values
 */
export const generateUniqueColors = (count, usedColors = []) => {
    if (count <= 0) return [];
    
    // Create a pool of available colors excluding already used ones
    const availablePool = AVAILABLE_COLORS.filter(color => !usedColors.includes(color));
    const colors = [];
    
    // If we need more colors than available, we'll have to reuse some
    const usePool = availablePool.length > 0 ? availablePool : AVAILABLE_COLORS;
    
    for (let i = 0; i < count; i++) {
        let selectedColor;
        
        if (i < usePool.length) {
            // Use colors from the pool in order for better distribution
            selectedColor = usePool[i];
        } else {
            // If we need more colors than available, pick randomly but avoid recent ones
            const recentColors = colors.slice(-5); // Avoid last 5 colors
            const nonRecentColors = usePool.filter(color => !recentColors.includes(color));
            const selectionPool = nonRecentColors.length > 0 ? nonRecentColors : usePool;
            selectedColor = selectionPool[Math.floor(Math.random() * selectionPool.length)];
        }
        
        colors.push(selectedColor);
    }
    
    return colors;
};

/**
 * Generate a color that contrasts with existing colors
 * @param {string[]} existingColors - Array of existing colors to contrast with
 * @returns {string} A hex color value
 */
export const getContrastingColor = (existingColors = []) => {
    if (existingColors.length === 0) {
        return getRandomColor();
    }
    
    // Try to find a color that's not in the existing colors
    const unusedColors = AVAILABLE_COLORS.filter(color => !existingColors.includes(color));
    
    if (unusedColors.length > 0) {
        // Return a random unused color
        return unusedColors[Math.floor(Math.random() * unusedColors.length)];
    }
    
    // If all colors are used, just return a random one
    return getRandomColor();
};